import { Link } from "react-router-dom";
import { useState, useEffect } from 'react';
import './headers.css';
import { logoutUser } from '../../../services/authService';
import { SET_LOGIN } from '../../../redux/features/auth/authSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { selectName } from '../../../redux/features/auth/authSlice';
import { HiMenuAlt3 } from "react-icons/hi";
import { IoClose } from "react-icons/io5";
import jokalogo from "../sidebar/megertu3.png";
import menu from '../sidebar/menu';
import SidebarItems from '../sidebar/SidebarItems';
import { MdCalculate } from "react-icons/md";

const Header = ({ isOpen, toggle }) => {
  const dispatch    = useDispatch();
  const navigate    = useNavigate();
  const name        = useSelector(selectName);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // ✅ Lock body scroll when mobile sidebar is open
  useEffect(() => {
    if (windowWidth <= 768) {
      document.body.style.overflow = isOpen ? "hidden" : "";
    }
    return () => { document.body.style.overflow = ""; };
  }, [isOpen, windowWidth]);

  const logout = async () => {
    try {
      await logoutUser();
      localStorage.removeItem("firstname");
      localStorage.removeItem("userType");
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      dispatch(SET_LOGIN(false));
      navigate("/login");
    } catch (error) {}
  };

  const isMobile = windowWidth <= 768;

  return (
    <div style={{ transition: "1.2s" }}>
      <header className="d-flex flex-wrap align-items-center justify-content-center
                          justify-content-md-between py-3 border-bottom"
        style={{ paddingLeft: "5px" }}>

        {isMobile ? (
          <>
            {/* ── Mobile header bar ─────────────────────────── */}
            <div className="me-auto">
              <HiMenuAlt3
                onClick={toggle} size={23}
                style={{ cursor: "pointer" }} color="black"
              />
            </div>
            <div className="me-auto">
              <h3 style={{ color: "black" }}>
                Welcome, <span style={{ color: "red" }}>{name}</span>
              </h3>
            </div>
            <Link>
              <button
                type="button"
                className="btn btn-outline-primary me-2"
                onClick={logout}
                style={{ marginTop: "0px", marginBottom: "5px", fontSize: "1.5rem" }}>
                Sign-out
              </button>
            </Link>

            {/* ── Backdrop ──────────────────────────────────── */}
            {isOpen && (
              <div
                className="mobile-backdrop"
                onClick={toggle}
              />
            )}

            {/* ── Mobile slide-in sidebar ───────────────────── */}
            <div className={`sidebar1 mobile-sidebar ${isOpen ? "mobile-sidebar-open" : ""}`}>
              <div className="top_section justify-content-md-between">
                <Link to="/" onClick={toggle}>
                  <img
                    src={jokalogo} alt="jokalogo" width={100} height={70}
                    style={{ paddingLeft: "10px", cursor: "pointer" }}
                  />
                </Link>
                <div
                  className="bars"
                  style={{ marginLeft: "80px" }}>
                  <IoClose onClick={toggle} size={23} style={{ cursor: "pointer" }} />
                </div>
              </div>
              <div className="menu">
                {menu.map((item, index) => (
                  <SidebarItems
                    key={index} item={item} isOpen={true}
                    onNavigate={toggle}
                  />
                ))}
              </div>
            </div>
          </>
        ) : (
          <>
            {/* ── Desktop header bar ────────────────────────── */}
            <div className="nav col-12 col-md-auto mb-2 justify-content-center mb-md-0">
              <h3 style={{ color: "black" }}>
                Welcome, <span style={{ color: "red" }}>{name}</span>
              </h3>
            </div>
            <div className="col-md-8 text-end justify-content-center">
              <a
                href="https://ceramics-calculator.vercel.app/"
                target="_blank" rel="noopener noreferrer"
                className="btn btn-outline-primary me-3 mt-0 mb-1 fs-3">
                <MdCalculate size={18} className="mb-1" />
                Calculator
              </a>
              <Link to="/Profile">
                <button type="button" className="btn btn-outline-primary me-2 mt-0 mb-1 fs-3">
                  Profile
                </button>
              </Link>
              <Link>
                <button
                  type="button"
                  className="btn btn-outline-primary me-2 mt-0 mb-1 fs-3"
                  onClick={logout}>
                  Sign-out
                </button>
              </Link>
            </div>
          </>
        )}

      </header>
    </div>
  );
};

export default Header;